import { money } from './ui'

// Extras for this visit (0087), read: the list on a visit, its money and its words. No screens here, so History and
// the price lines can use it without the booking form's pieces. src/extras.ts builds the form's box on it.

export type ExtraKind = 'conservatory' | 'gutters' | 'other'
export interface Extra { kind: ExtraKind; name: string; count: number; each_pence: number | null }

export function extrasOf(json: string | Extra[] | null | undefined): Extra[] {
  if (!json) return []
  try {
    // A change still waiting for signal lays its list over the visit as it was sent, not as text (GPT-6.1's review 9).
    const list = typeof json === 'string' ? JSON.parse(json) : json
    return Array.isArray(list) ? list.filter((x) => x && typeof x.name === 'string' && Number.isInteger(x.count)) : []
  } catch { return [] }
}
export const extraPence = (e: Extra): number => e.count * (e.each_pence ?? 0)
export const extrasTotal = (list: Extra[]): number => list.reduce((s, e) => s + extraPence(e), 0)
export const extrasTotalOf = (json: string | null | undefined): number => extrasTotal(extrasOf(json))
// "Conservatory roof · 4 panels" (the work, for anyone), and its money when it has it.
export function extraWork(e: Extra): string {
  return e.kind === 'conservatory' ? `${e.name} · ${e.count} panel${e.count === 1 ? '' : 's'}` : e.count > 1 ? `${e.name} × ${e.count}` : e.name
}
export function extraWords(e: Extra): string {
  return e.each_pence === null || e.each_pence === undefined ? extraWork(e) : `${extraWork(e)} ${money(extraPence(e))}`
}

